import React from "react";

function PersonalInfoSection({
  firstName,
  lastName,
  description,
  onFirstNameChange,
  onLastNameChange,
  onDescriptionChange,
  firstNameError = null,
  lastNameError = null,
  descriptionError = null,
}) {
  return (
    <section
      className="ap-pane"
      aria-labelledby="ep-pane-personal"
      data-section="personal-info"
    >
      <header className="ap-pane__head">
        <h2 id="ep-pane-personal">
          <i className="fa-solid fa-user" aria-hidden="true"></i>Особисті дані
        </h2>
        <p>Ім'я та прізвище показуються на вашому профілі та у всіх ваших оголошеннях.</p>
      </header>

      <div className="ap-row ap-row--2">
        <div className="ap-field">
          <label htmlFor="first-name">
            Ім'я <span className="req" aria-hidden="true">*</span>
          </label>
          <input
            type="text"
            className={`form-control${firstNameError ? " is-invalid" : ""}`}
            id="first-name"
            name="first_name"
            data-field="first_name"
            autoComplete="given-name"
            required
            aria-invalid={firstNameError ? "true" : undefined}
            aria-describedby={firstNameError ? "first-name-error" : undefined}
            value={firstName}
            onChange={(e) => onFirstNameChange(e.target.value)}
          />
          {firstNameError ? (
            <div
              id="first-name-error"
              className="invalid-feedback d-block"
              role="alert"
            >
              {firstNameError}
            </div>
          ) : null}
        </div>
        <div className="ap-field">
          <label htmlFor="last-name">
            Прізвище <span className="req" aria-hidden="true">*</span>
          </label>
          <input
            type="text"
            className={`form-control${lastNameError ? " is-invalid" : ""}`}
            id="last-name"
            name="last_name"
            data-field="last_name"
            autoComplete="family-name"
            required
            aria-invalid={lastNameError ? "true" : undefined}
            aria-describedby={lastNameError ? "last-name-error" : undefined}
            value={lastName}
            onChange={(e) => onLastNameChange(e.target.value)}
          />
          {lastNameError ? (
            <div
              id="last-name-error"
              className="invalid-feedback d-block"
              role="alert"
            >
              {lastNameError}
            </div>
          ) : null}
        </div>
      </div>

      <div className="ap-row">
        <div className="ap-field ap-field--wide">
          <label htmlFor="description">Опис</label>
          <textarea
            className={`form-control${descriptionError ? " is-invalid" : ""}`}
            id="description"
            name="description"
            data-field="description"
            rows="4"
            aria-describedby={
              descriptionError
                ? "description-hint description-error"
                : "description-hint"
            }
            aria-invalid={descriptionError ? "true" : undefined}
            placeholder="Розкажіть про себе, спеціалізацію, регіон роботи…"
            value={description}
            onChange={(e) => onDescriptionChange(e.target.value)}
          />
          <small id="description-hint" className="form-hint">
            Цей текст бачать клієнти на вашій сторінці.
          </small>
          {descriptionError ? (
            <div
              id="description-error"
              className="invalid-feedback d-block"
              role="alert"
            >
              {descriptionError}
            </div>
          ) : null}
        </div>
      </div>
    </section>
  );
}

export default PersonalInfoSection;
